export const FETCH_PAGES = 'fetchPages';
